import type { StateCreator } from 'zustand';
import type {
  PreferencesState,
  ThemeSlice,
} from '../types/preferencesStoreTypes';

export const createThemeSlice: StateCreator<
  PreferencesState,
  [],
  [],
  ThemeSlice
> = (set) => ({
  theme: 'system',
  setTheme: (theme) => set({ theme }),
  // Corners live in the theme slice rather than in one of their own because
  // they are persisted, applied and reset through exactly the same three
  // places `theme` is, and a second slice would only duplicate that wiring.
  //
  // SQUARE IS THE DEFAULT, and this line is the only thing in the change that
  // is a design decision rather than plumbing. Everything before it was built
  // so that flipping this word is all it takes, and so that flipping it back
  // is too.
  //
  // An existing install keeps whatever it has: zustand-persist merges the
  // stored state over these defaults, and anyone who has opened the app has a
  // stored `theme`, so their envelope simply gains `cornerStyle: 'square'` on
  // the next write. There is no migration and nothing to undo.
  cornerStyle: 'square',
  setCornerStyle: (cornerStyle) => set({ cornerStyle }),
});
